import { render, staticRenderFns } from "./VipSetting.vue?vue&type=template&id=fd934a96&scoped=true&"
import script from "./VipSetting.vue?vue&type=script&lang=js&"
export * from "./VipSetting.vue?vue&type=script&lang=js&"
import style0 from "./VipSetting.vue?vue&type=style&index=0&id=fd934a96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd934a96",
  null
  
)

export default component.exports